module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("CHAPTER 2")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "chap-image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/chap.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("“I")]), _vm._v("’m sorry,” Mattie said miserably as they drove away in a cloud of dust. “I saw that he was stealing, and I—I know I should have kept my mouth shut. I didn’t think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I do wish you had,” Maya said. Even the back of her head looked tense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Mattie flared up. “That’s not fair! You do the same thing in your readings all the time! Remember that lady from last week? The one you told not to accept her boyfriend’s proposal? She was furious with you! It’s so hard not to say anything!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Now, now,” Da said, trying to soothe them. “You’re two sides of the same coin, you both.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“We are not,” Mattie said automatically. She hated it when Da compared her to Maya.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Maya turned in her seat to look at her. She didn’t seem as mad anymore. “I know how hard it is,” she said. “It will always be difficult for you, as it is for me. The boys and Tib have it easier.”")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What did Mattie do?” Tibby piped up. “Is she in trouble again? Was it that bampot who was yelling?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A bampot was an idiot, in Scots. Tibby called almost everyone that; she loved the sound of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mattie’s not in trouble,” Da said. “It was just time to go. And now it’s time for you to do some lessons—you missed your history on Friday because we were setting up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“A very good idea,” Maya agreed. “We were talking about … what? The Oregon Trail?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Wagon trains!” Bell exclaimed. “Indian attacks!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The Donner Party,” Mattie muttered, but Maya heard her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mattie,” she cautioned, with a glance at Tibby.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Sorry,” Mattie said, though she was pretty sure Tibby would love the story of how the Donner group had to eat each other to keep from starving in the mountains on their way to the West.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Maya and Tibby went through the alphabet first, with Da making letters materialize and hang over the backseat and Tibby trying to grab them and name them. Da could make an "), _c('em', [_vm._v("S")]), _vm._v(" with a forked tongue like a snake or a "), _c('em', [_vm._v("B")]), _vm._v(" that buzzed like a bumblebee, and Tibby shouted the letters, hissing and buzzing along with them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Then Maya talked about the Oregon Trail, and Bell and Mattie looked at illusions of covered wagons, and petticoats, and the sunburned faces of pioneers. Sometimes Da concentrated so hard on the picture he was materializing that the car swerved, and then the illusion would pop like a bubble and disappear as he pulled back into his lane.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v(" “But why would they want to go west?” Mattie asked. She’d never understood it. “How could they leave their homes and everyone they loved to go somewhere that they knew was going to be hard and dangerous and horrible?” She knew the Ingalls family did it in the Little House stories, which she loved, but it wasn’t the traveling parts of those books that she read and reread. It was the family parts, where they spent the long winter evenings playing music in front of the fire or worked together in the fields. And most of all, it was the parts in the houses—the log cabin in the Big Woods, the house Pa built on the prairie, even the dirt dugout on the banks of Plum Creek. The places where they settled and stayed.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That’s what people do,” Da said mildly. “Humans have always explored. From Europe to America, west to California, up to the moon. It’s ingrained.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Not in me,” Mattie said, half under her breath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Enough, Mattie,” Maya warned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Would you really want to live just in one place?” Bell asked her. He couldn’t believe it, no matter how many times Mattie told him she would. “Wouldn’t you be bored? Nothing new to see, nobody new to know? Everything the same, every day?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I think it would be amazing,” Mattie said softly. “Living in a real house, going to school …” But Maya sighed in annoyance, so she dropped it.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("They ate sandwiches at a roadside rest stop as night fell. The moon, round and orange, came into view over the treetops that lined the narrow road leading south. The truck couldn’t make it on the superhighways, or even the regular highways. When Da pushed it over forty-five miles an hour, it developed a cough and started to shake like an old man with the flu. So they stuck to the smaller roads wherever they went. Mattie was ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("glad. There was a lot to see out the window, usually—houses and towns and sometimes even people walking along the side of the road. She watched the moonlit view slide by, and after a while, with the clanking of the truck engine and the regular breathing of her brother and sister as a lullaby, she fell asleep.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She woke to quiet. Not just quiet, but "), _c('em', [_vm._v("too")]), _vm._v(" quiet. The sound of the truck motor had stopped. She could hear the summer locusts screeching outside, and the hood of the truck groaned as Da opened it to peer in at the engine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What’s wrong?” Mattie whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It just … stopped,” Maya said, running her hands through her thick hair, usually smooth and neat, so it stood out crazily around her head. “Not a bit of warning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Mattie rubbed the sleep from her eyes. “Uh-oh,” she said. “Maybe we’re out of gas?” That had happened before. The gas gauge wasn’t too reliable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Not this time,” Maya said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Mattie eased the door open and climbed out. In the gleam of moonlight and the sharper glare of the headlights, she peered under the hood with Da. She had no idea what she was looking at, but she could tell that things weren’t supposed to be smoking in there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That doesn’t look good,” she noted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No,” Da agreed. “Might be a fair idea for us to get out of the truck.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Maya woke Bell, and Mattie helped him stagger out as Da lifted Tibby, still sound asleep, from her booster seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What now?” Maya asked. She sounded very tired.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“We walk, I suppose,” Da said. “I am sorry, love. I thought the last fix would hold awhile.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Not your fault,” Maya said in a brisker tone.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v(" “Can’t you just image up a new engine?” Bell asked, whiny at being awakened. “I don’t want to walk.”")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Da gave Bell a half-frown, half-smile. “You know that wouldn’t work. They dinna stay.” He pointed, and for a moment, a car engine hung in the air between them, as real-looking as the one in the truck. Then it disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“We passed a sign not far back with a town name on it,” Maya said. “So we should get to the town before long. Surely they will have a mechanic.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("And a motel?")]), _vm._v(" Mattie wanted to say, but she knew better. They had the wagon, so they didn’t need to waste money they couldn’t spare on a motel. But they were walking away from the wagon, and she really, really wanted a shower.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Wait,” she said. “I need to change. I’m not going to any town dressed like this.” They’d left the fair in such a rush that she was still wearing her mind-reading outfit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You look fine,” Maya said impatiently.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I do not!” Mattie protested. “Just let me get my jeans and a T-shirt. It’ll only take a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s all right, Maya love,” Da said to Maya, handing Tibby to her, then smoothing down her wild hair. “I’ll get them—just in case the truck goes up.” The engine wasn’t smoking anymore so Mattie didn’t think there much danger of that, but Maya let him go.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“They’re in my trunk, on top,” Mattie told him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He was back quickly with the clothes, and Mattie changed behind the wagon, tossed her skirt and top inside, and locked the door. Then they set off on foot down the road.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("The moon lit the way or it might have been impossible. Bell had a flashlight attached to an all-purpose knife that he always carried, but its narrow beam barely touched the huge darkness ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("around them. Everyone was exhausted, and things rustled in the brush on the side of the road, making Mattie jump. She was just about ready to sit down on the asphalt and refuse to take another step when she saw a sign down the road"), _c('em', [_vm._v(". Welcome to Frog Creek")]), _vm._v(", it read in the unsteady glow of Bell’s flashlight. "), _c('em', [_vm._v("Population 2,464.")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("They staggered on past a row of houses with wraparound porches and huge trees in their front yards. All the windows were dark. Everyone was sound asleep. Then they were in the town, really just a street with some stores lining it. There were a few streetlights, but the shops were closed up tight—except for one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Look, it’s a diner!” Bell said, excited. “Can we get something to eat? I’m so hungry!” Mattie realized that she was, too. The only food she’d had was those sandwiches, hours before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I could eat,” Da said, shifting Tibby’s weight. So they headed toward the diner, one of the sort Mattie liked best, old-fashioned with a silvery metal front.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A bell over the door tinkled when Bell pushed it open, and a woman sitting at the counter swiveled on her stool to look. She had a round face below a halo of white hair, and her cheeks creased into a hundred wrinkles when she smiled. It was the kind of smile that you had to smile back at.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Are you open?” Da asked, lowering Tibby to the ground. She scrabbled like a kitten to keep her hold on him and wailed softly as her feet hit the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Poor little thing, so tired!” the woman said, standing up and folding the newspaper she’d been reading. “You’re here, so we’re open. We open early for the farmers, and it’s nearly dawn. They’ll be coming in soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yay!” Bell shouted. He scooted into the nearest booth.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("“You folks just passing through?” the woman asked, ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("handing them menus as they crowded into the booth. Mattie and Maya and Tibby sat on one side, Bell and Da on the other. It was a really old-fashioned place, with jukeboxes on the wall at each booth. Mattie and Bell flipped through the lists of songs, looking for something they knew, but it was all country music from years and years ago.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“We broke down, just outside town,” Maya said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Bad luck!” the woman exclaimed. “The garage opens around nine, if Jacko wants to work. Depends on the kind of night he’s had.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Mattie opened the menu. Everything looked good to her. “Pancakes,” she said. “Sausage. Juice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Me, too,” Bell said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Me, too!” cried Tibby, waking fully. “Pancakes!” The mess she made with syrup could be epic, but Maya and Da were too tired to protest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Pancakes all around?” the woman asked, and Da nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Coffee, please,” he said. “Is it strong?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’ll wake you up,” the woman promised. “I’m Audra, by the way. It’s my place.” The menus said "), _c('em', [_vm._v("Audra’s")]), _vm._v(", with a painted picture of the diner on them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Audra went back to the kitchen, and cooking noises and good smells soon came wafting out. It wasn’t long before she emerged again, first with steaming mugs of coffee and glasses of orange juice, and then with enormous plates of pancakes, butter melting on top, and a pitcher of real maple syrup, warmed, for the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You folks on vacation?” Audra inquired as she passed the plates around. Mattie gulped orange juice thirstily. It didn’t taste much like the juice she was used to. It tasted like real oranges. It was delicious.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Da and Maya exchanged glances. “Not exactly,” Da said. “We’re … performers.”")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Artistes,” Bell corrected him. It was what Maya always said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Oh, you’re with the circus!” Audra exclaimed. “I should have guessed, the way you look.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Mattie glanced down at her jeans. What did she mean? Then she saw Audra smile at Maya, taking in her kohl-lined eyes and rose-colored sari, her rings and henna-painted hands and the silver bracelet that wrapped around her upper arm like a snake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“We just put up the poster, see?” Audra pointed to a bulletin board near the door, and Mattie jumped up to look, Da following. There was a circus poster, all right. Gold and black and red, it showed a big top, a clown with a round red nose, and two tigers jumping through flaming hoops. Big gold letters announced "), _c('em', [_vm._v("Master Morogh’s Circus of Wonders")]), _vm._v(". Below were performance dates and times. It would open Thursday, in just five days, and run through Monday, Labor Day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s been a long time since we had a circus here,” Audra said. “My grandkids are wild to go. I have to admit, I’m pretty wild to go myself!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Da stood behind Mattie, looking at the poster. Then he squeezed her shoulder and said to Audra, “Well, I guess we’ll see you there, then!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Really?” Mattie said as they headed back to the table. “A circus? Really?”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("“Could be,” Da said, in a way that usually meant yes. Mattie felt a stir of excitement in her stomach. If she had to choose between a fair and a circus, she’d take a circus anytime. Circuses had other families, families of trapeze artists and ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("animal trainers and tumblers. There weren’t many circuses left, though, not the kind that would take on a whole family who did magic. They were either huge, three-ring deals or the kind that performed in fancy theaters with music and light shows. The Marvelwoods hadn’t been with a circus since Mattie was seven years old.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The circus is here through the long weekend,” Da said to Maya when they sat down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What good timing for us!” Maya exclaimed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“If it’s the right kind,” Da reminded her. “The poster makes it look small. It could suit us well, if they have a need for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yay, a circus! Clowns and elephants!” Bell said, and Tibby echoed, “Yay!” even though she didn’t know what she was cheering for.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("They sat back down and dug into the pancakes, and they were "), _c('em', [_vm._v("good.")]), _vm._v(" Tibby was head-to-toe syrup in no time, but not even Maya cared. They just ate and ate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("When everyone was done, they sat there groaning in a quiet, pleased way for a little while. The door opened, and a group of men came in—definitely the farmers Audra had mentioned, with their overalls and caps. The men ordered huge plates of eggs, ignoring the strangers sitting nearby, not even noticing Maya and her kohl-ringed sidelong glance. Audra had to hustle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Da stood up to pay the bill and chatted with Audra by the cash register for a few minutes. Then he came back to the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The circus is set up just the other side of town,” he said. “Not too far.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Ohhh,” Mattie moaned. “I can’t walk anymore!”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v(" “All of us are tired, Mattie,” Maya pointed out. “The sooner we get things settled, the sooner we can rest.” Mattie scowled at her but scooted from the booth, and they headed out of the diner.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“See you Thursday!” Audra called as the door closed behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The sun was up now, but it was still early. They walked by a clothing shop with a really pretty dress in the window, a hardware store, and a place that looked like it sold cards and books and a bunch of stuff that nobody really needed. Besides the diner, that was about it for the town. Then they passed a bank, and the sign in front read "), _c('em', [_vm._v("Frog Creek Credit Union.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Is it Frog Creek, North Carolina?” Mattie asked. “Or did we get to South Carolina while I was asleep?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s South Carolina,” Da said. “We passed the border a while back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Da had lifted an exhausted Tibby to his shoulders by the time they reached the dusty pasture where the circus was setting up. A high wooden fence surrounded it, and beyond the fence a forest of thick trees loomed. From this distance they could see the top of the big tent and hear the sounds of hammering and sawing and the occasional trumpet of an elephant. Mattie was glad: she really liked elephants, and not every small circus had them. They were a lot of trouble, Da always said, and expensive to feed.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("The sun warmed Mattie’s back as they came to the place where the welcome arch would be set up. In a few days, it would likely have a big banner with the circus name on it, and the ticket taker would sit just inside. Right now, though, it was just a gap in the fence. They stood together, gathering their strength for the introductions and conversations and ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("explanations that would happen as soon as they stepped into the circus lot.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And then Mattie saw a man coming toward them. She could tell that he wasn’t a roustabout—one of the circus workers—but some sort of artiste. He was short and kind of round, and Mattie noticed when he got close enough that he had unusual greenish-gray eyes with very high, arched brows. He wore pants with a gold stripe down the sides, a spotless white shirt with the sleeves rolled up, and black gloves. His hair, as shiny and black as his boots, was slicked back, and he had a funny little V-shaped beard that came to a sharp point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Tibby bounced with excitement on Da’s shoulders. “The ringmaster!” she squealed. “Are you the ringmaster?” She hadn’t even been born the last time they’d been with a circus, but Da and Maya had told her stories about them, and Da had imaged up lions and tigers, clowns and acrobats and trapeze artists. She knew what a ringmaster would look like.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The man smiled and bowed as Da set Tibby down. “Hello, hello, hello!” he welcomed them in a low, rich voice with an accent like Da’s. It was funny, Mattie thought, such a big voice coming from such a small person. “Yes, my dear, I am Master Morogh, owner and ringmaster.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And then Mattie’s mouth dropped open in surprise as he said, “Welcome to my Circus of Wonders, Marvelwoods!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c89f989","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Chapter02.vue
// module id = 69
// module chunks = 0